import { render, staticRenderFns } from "./DialogRank.vue?vue&type=template&id=5a14b5b4&scoped=true&"
import script from "./DialogRank.vue?vue&type=script&lang=js&"
export * from "./DialogRank.vue?vue&type=script&lang=js&"
import style0 from "./DialogRank.vue?vue&type=style&index=0&id=5a14b5b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a14b5b4",
  null
  
)

export default component.exports